interface ProgressBarProps {
  value: number; // 0..100
  label?: string;
  variant?: 'default' | 'success' | 'danger';
}

export function ProgressBar({ value, label, variant = 'default' }: ProgressBarProps) {
  const barColor = variant === 'success' ? 'bg-green-500' : variant === 'danger' ? 'bg-red-500' : 'bg-brand-600';
  return (
    <div>
      {label && <div className="mb-1 flex justify-between text-xs text-slate-500 dark:text-slate-400">
        <span>{label}</span>
        <span>{Math.round(value)}%</span>
      </div>}
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
        <div
          className={`h-full rounded-full transition-all duration-200 ${barColor}`}
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}
